import styled, { css } from 'styled-components';
import { ReactComponent as EmptyTableSvg } from 'src/assets/emptyMyTicketsTable.svg';
import { ReactComponent as EmptyFiltersTableSvg } from 'src/assets/emptyFiltersMyTicketsTable.svg';

export const TableWrapper = styled.div`
  padding: 0px 12px;
  background: ${(props) => props.theme.mainBackgorund};
  min-height: 100vh;
  width: 100%;
  overflow: auto;
  position: relative;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableBodyCell = styled.td`
  padding: 12px 16px;
  text-align: left;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  align-content: center;
  color: ${(props) => props.theme.textMainColor};

  .ellipsis {
    display: -webkit-box;
    max-width: 230px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const EmptyTableIcon = css`
  width: 100%;
  height: 100%;
`;

export const NoTicketsIcon = styled(EmptyTableSvg)`
  ${EmptyTableIcon}
`;

export const NoFiltersMatchIcon = styled(EmptyFiltersTableSvg)`
  ${EmptyTableIcon}
`;
